import { CellContext } from '@tanstack/react-table'

import { Log, MandatoryLogInformation, RouteSelectionMode } from '@/types/logs'
import { useManageLogOriginalRoute } from '@/modules/CombinedLogs/hooks/useManageLogOriginalRoute'
import { tableCellStyles } from '@/ui/Table'
import { MissingInfo } from './MissingInfo'

import styles from '../../../ui/CombinedLogs.module.scss'

interface Props extends CellContext<Log, string[]> {
    isDataLoading: boolean
}

export const Routes = ({ isDataLoading, row, getValue }: Props) => {
    const { getElementAttributes } = useManageLogOriginalRoute(isDataLoading)
    const value = getValue()

    return (
        <div>
            <div
                {...getElementAttributes({
                    className: tableCellStyles.bold,
                    isOriginalTrip: !!row.original.originalTrip,
                })}
            >
                {row.original.routeSelectionMode === RouteSelectionMode.All ? (
                    '-'
                ) : row.original.routeSelectionMode === RouteSelectionMode.Default && value && value.length > 0 ? (
                    value.join(', ')
                ) : (
                    <MissingInfo label="route" log={row.original} field={MandatoryLogInformation.Route} />
                )}
            </div>

            {row.original.originalTrip && row.original.originalTrip.routes && (
                <div className={styles.originalRoutesFormContainer}>
                    <p className={tableCellStyles.bold}>{row.original.originalTrip.routes.join(', ')}</p>
                </div>
            )}
        </div>
    )
}
